"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDetail = exports.newsList = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 新闻列表
exports.newsList = (params) => http().post('/news/list', params);
// 新闻详情
exports.newDetail = (params) => http().post('/news/detail', params);
